import React from 'react';
import PropTypes from 'prop-types';
import MultiSelect from './components/multiSelect';

export const options = [
  {
    id: 1,
    label: 'Internship',
    description: 'First professional opportunity post education or when transitioning.',
    value: 'internship',
  },
  {
    id: 2,
    label: 'Entry level',
    description: '0 to 2 years experience.',
    value: 'entry_level',
  },
  {
    id: 3,
    label: 'Mid-senior level',
    description: 'More than 2 years of experience.',
    value: 'mid-senior_level',
  },
  {
    id: 4,
    label: 'Manager',
    description: 'Roles responsible for a team (entry and mid level).',
    value: 'manager',
  },
  {
    id: 5,
    label: 'Director',
    description: 'Senior-level managers managing teams of managers.',
    value: 'director',
  },
  {
    id: 6,
    label: 'Executive',
    description: 'Executive-level managers and above, including C-level positions.',
    value: 'executive',
  },
];

export const Experience = ({ onChange, data, variant }) => (
  <MultiSelect
    initialData={data}
    onChange={(experience) => onChange('experience', experience)}
    options={options}
    type="checkbox"
    variant={variant}
  />
);

Experience.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  variant: PropTypes.string,
};

Experience.defaultProps = {
  variant: 'onboarding',
};

export default Experience;
